/**
 * Author：brand
 * Creation Time：2019-05-11 10:44
 * Email：brandhuang@qq.com
 */

import ax from '../axios'

/**
 * 获取用户信息
 * @param params
 */
export function userInfoAPI (params) {
  return ax({
    url: '/wlapi/public/userInfo',
    method: 'POST',
    params
  })
}

/**
 * 改变客服状态
 * @param params
 */
export function userStatusAPI (params) {
  return ax({
    url: '/wlapi/user/updateAgentStatus',
    method: 'POST',
    params
  })
}
/**
 * 新功能弹窗
 */
export function latestLog () {
  return ax({
    url: '/wlapi/updateLog/latestLog',
    method: 'POST'
  })
}
/**
 * 改变客服状态
 */
export function logUnReadCount () {
  return ax({
    url: '/wlapi/updateLog/logUnReadCount',
    method: 'POST'
  })
}
/**
 * 退出登录
 * @param params
 */
export function logout (params) {
  return ax({
    url: '/wlapi/user/logout',
    method: 'POST',
    params
  })
}